import { REDUCE_PAYMENT_TRANSFER_RESULT_ERRORS } from '../../constants/actions/payment';

export function reducePaymentTransferResultErrors(payload) {
    return {
        type: REDUCE_PAYMENT_TRANSFER_RESULT_ERRORS,
        payload,
    };
}
